import {Directive, ElementRef, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {ClinicalStatusService} from "../../../../app.services/clinical/services/clinical.status.service";
import {UserContextService} from "../../../../app.services/user.context";
import { RtlService } from "common/rtl/services/rtl.service";

@Directive({
	selector: '[cpBorderExamStatusColor]',
})
export class BorderExamStatusColorDirective implements OnInit, OnChanges {
	@Input() statusKey: number;

	constructor(private elementRef: ElementRef, private clinicalStatusService: ClinicalStatusService, private userContextService: UserContextService,
		private rtlService: RtlService
	) {
	}

	ngOnInit() {
		let color = this.getBorderColor();
		if (color) {
			let side = this.rtlService.isRtl() ? 'right' : 'left';
			let css = `border-${side}-color:rgb(${color});`;
			this.elementRef.nativeElement.setAttribute("style", css);
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if(changes['statusKey'] && !changes['statusKey'].isFirstChange()){
			let color = this.getBorderColor();
			if (color) {
				let side = this.rtlService.isRtl() ? 'right' : 'left';
				let css = `border-${side}-color:rgb(${color});`;
				this.elementRef.nativeElement.setAttribute("style", css);
			}
		}
	}
	private getBorderColor() {
		let color: string;
		if (this.userContextService.getCachedUserContext().userPreferences.schedulerOptions?.useAlternateColorsForSchedule || false) {
			color = this.clinicalStatusService.getStatusByStatusKey(this.statusKey).alternateColor;
			if (!color) {
				color = this.clinicalStatusService.getStatusByStatusKey(this.statusKey).color;
			}
		} else {
			color = this.clinicalStatusService.getStatusByStatusKey(this.statusKey).color;
		}
		return color;
	}

}
